export default {
  register_as: "在 {{- date}} 上註冊成為網紅",
  edit_profile: "編輯個人資料",
  rating_from_admin: "招募案件方對網紅的評價",
  sns_activity: "網紅活動的社交媒體",
  self_introduction: "身為網紅的自我介紹（專業領域的介紹）",
  cancel_change_confirm: "您想取消您的更改嗎？",
  upload_avatar: "更改照片",
};
